<template>
  <div class="float" v-show="canUseRent">
    <div @click="toRecycle">
      <div class="item">
        <img src="../../../assets/recycle.png" alt="" />
        <div class="words">回收</div>
      </div>
    </div>
    <!--    <div @click="changeFloat">-->
    <!--      <img src="../../../assets/stone.png" alt="" class="stone" />-->
    <!--    </div>-->
    <!--    <div v-show="isOpen">-->
    <!--      <div class="item">-->
    <!--        <img src="../../../assets/afterSale.png" alt="" />-->
    <!--        <div class="words">售后</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-show="isOpen && canUseRent" @click="toAppreciate">-->
    <!--      <div class="item">-->
    <!--        <img src="../../../assets/appreciate.png" alt="" />-->
    <!--        <div class="words">鉴赏</div>-->
    <!--      </div>-->
    <!--      <wx-open-launch-weapp-->
    <!--        id="launch-btn"-->
    <!--        :appid="rentAppid"-->
    <!--        :path="`pages/wm-cloud-jianshang/scan-jsdetail/index?barCode=${barCode}`"-->
    <!--        @error="handleErrorFn"-->
    <!--        @launch="handleLaunchFn"-->
    <!--      >-->
    <!--        <script type="text/wxtag-template">-->
    <!--          <style>.btn { padding: 12px }</style>-->
    <!--          <button class="btn"></button>-->
    <!--        </script>-->
    <!--      </wx-open-launch-weapp>-->
    <!--    </div>-->
    <div @click="backTop">
      <img src="../../../assets/backTop.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    barCode: {
      type: String,
      default: () => "",
    },
    canUseRent: {
      type: Boolean,
      default: () => undefined,
    },
  },
  data() {
    return {
      isOpen: false,
      //test
      // rentAppid: "wxd484467da4a1a595",
      //PRO
      rentAppid: "wx84c4cfd4196e80ed",
    };
  },

  watch: {
    canUseRent: function () {
      this.changeFloat();
    },
  },

  methods: {
    changeFloat() {
      let float = document.querySelector(".float");
      // if (!this.isOpen && this.canUseRent) {
      //   float.style.height = "48.533333vw";
      //   this.isOpen = true;
      // } else if (!this.isOpen && !this.canUseRent) {
      //   float.style.height = "34.533333vw";
      //   this.isOpen = true;
      // } else {
      float.style.height = "20.8vw";
      // this.isOpen = false;
      // }
    },
    backTop() {
      // 平滑回到顶部：统一处理 iOS / Android，避免未定义 isAndroid 报错
      const ua = navigator.userAgent;
      const isiOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua);
      // 兼容性获取可滚动元素
      const scrollEl =
        document.scrollingElement ||
        (isiOS ? document.documentElement : document.body) ||
        document.documentElement;
      const start = scrollEl.scrollTop;
      const duration = 300; // 动画时长 ms
      const startTime = Date.now();
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      function step() {
        const now = Date.now();
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = easeOutCubic(progress);
        scrollEl.scrollTop = start * (1 - eased);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    },
    toAppreciate() {
      // this.$router.push({ path: "/appreciate/login" });
    },
    // 打开失败
    handleErrorFn(e) {
      console.log("err", e);
    },
    // 打开app成功
    handleLaunchFn(e) {
      console.log("success", e);
    },
    toRecycle() {
      window.open(process.env.VUE_APP_RECYCLE_URL + "?barCode=" + this.barCode);
    },
  },
};
</script>

<style lang="less" scoped>
.float {
  position: fixed;
  top: 1000px;
  right: 0px;
  width: 88px;
  height: 156px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.5s;
  #launch-btn {
    width: 50px;
    height: 72px !important;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    opacity: 0;
    z-index: 10;
  }
  .item {
    width: 50px;
    height: 72px !important;
    position: absolute;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > img {
      width: 32px;
      height: 32px;
      display: block;
      margin: 0 auto;
    }
    .words {
      font-size: 24px;
      color: #666666;
    }
  }
  > div {
    width: 88px;
    height: 88px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #e2e4ea;
    position: relative;
    display: flex;
    justify-content: center;
    .stone {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  > div:last-child {
    width: 88px;
    height: 44px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #e2e4ea;
    position: relative;
    > img {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>
